// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3JexA","content":"GlobalSearch_content__1R_wL"};